import React from 'react';
import SectionHeading from '../components/SectionHeading';
import TestimonialCard from '../components/TestimonialCard';
import CTAButton from '../components/CTAButton';
import { TrendingUp, Users, Award, Building } from 'lucide-react';
const ImpactPage = () => {
  return <div className="w-full" data-id="element-1371">
      {/* Hero Section */}
      <section className="bg-navy text-white py-16" data-id="element-1372">
        <div className="container-custom text-center" data-id="element-1373">
          <h1 className="text-4xl md:text-5xl font-bold font-montserrat mb-6" data-id="element-1374">
            Our Impact
          </h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-1375">
            Transforming lives by helping entrepreneurs build successful
            businesses across diverse industries.
          </p>
        </div>
      </section>
      {/* Impact Stats */}
      <section className="section-padding" data-id="element-1376">
        <div className="container-custom" data-id="element-1377">
          <SectionHeading title="Making a Difference" subtitle="Through our programs, we're helping entrepreneurs achieve financial independence and build lasting legacies." data-id="element-1378" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-1379">
            <StatCard icon={<Users size={40} data-id="element-1381" />} number="100+" label="Entrepreneurs Supported" data-id="element-1380" />
            <StatCard icon={<TrendingUp size={40} data-id="element-1383" />} number="$15M+" label="Combined Annual Revenue" data-id="element-1382" />
            <StatCard icon={<Building size={40} data-id="element-1385" />} number="85%" label="Business Survival Rate" data-id="element-1384" />
            <StatCard icon={<Award size={40} data-id="element-1387" />} number="500+" label="Jobs Created" data-id="element-1386" />
          </div>
          <div className="bg-lightGray rounded-lg p-8 md:p-12" data-id="element-1388">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1389">
              <div data-id="element-1390">
                <h3 className="text-2xl font-bold text-navy mb-6 font-montserrat" data-id="element-1391">
                  Building Legacies
                </h3>
                <p className="mb-4" data-id="element-1392">
                  At Operation Launchpad, we measure our success by the success
                  of the entrepreneurs we serve. Every business that reaches $1M
                  in annual revenue represents:
                </p>
                <ul className="space-y-3 mb-6" data-id="element-1393">
                  <li className="flex items-start" data-id="element-1394">
                    <span className="text-gold mr-2" data-id="element-1395">•</span>
                    <span data-id="element-1396">
                      An entrepreneur achieving financial independence
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1397">
                    <span className="text-gold mr-2" data-id="element-1398">•</span>
                    <span data-id="element-1399">New jobs created in local communities</span>
                  </li>
                  <li className="flex items-start" data-id="element-1400">
                    <span className="text-gold mr-2" data-id="element-1401">•</span>
                    <span data-id="element-1402">Quality products and services for clients</span>
                  </li>
                  <li className="flex items-start" data-id="element-1403">
                    <span className="text-gold mr-2" data-id="element-1404">•</span>
                    <span data-id="element-1405">
                      A legacy that can be passed down to future generations
                    </span>
                  </li>
                </ul>
                <p data-id="element-1406">
                  Our nonprofit model allows us to focus on long-term impact
                  rather than short-term profit, ensuring that we can provide
                  the best possible support to those we serve.
                </p>
              </div>
              <div data-id="element-1407">
                <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Team collaborating on business strategy" className="rounded-lg shadow-md w-full h-auto" data-id="element-1408" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Success Stories */}
      <section className="section-padding bg-white" data-id="element-1409">
        <div className="container-custom" data-id="element-1410">
          <SectionHeading title="Success Stories" subtitle="Meet some of the entrepreneurs who have transformed their businesses through our program." data-id="element-1411" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-1412">
            <TestimonialCard quote="I struggled to grow my tech startup beyond $200K in revenue. Operation Launchpad provided the systems and mentorship I needed to scale to $1.2M in just 18 months while maintaining quality and client satisfaction." name="Michael Rodriguez" title="CEO of Rodriguez Technologies" image="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" data-id="element-1413" />
            <TestimonialCard quote="The mentorship and business systems provided by Operation Launchpad helped me avoid years of trial and error. My e-commerce company hit $1M in our second year, and we're now expanding to a second location with a team of 12 employees." name="Sarah Johnson" title="Founder of Johnson Retail" image="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" data-id="element-1414" />
            <TestimonialCard quote="I knew how to lead a team, but Operation Launchpad taught me how to build a business. Now my consulting firm employs 15 people and serves major clients in three states. The systems they provided were game-changers." name="David Thompson" title="Owner of Thompson Consulting" image="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" data-id="element-1415" />
            <TestimonialCard quote="I was working 80-hour weeks and barely making ends meet when I joined Operation Launchpad. Their mentorship helped me work smarter, not harder. Now I have a thriving digital marketing agency with proper systems and a work-life balance I never thought possible." name="Jennifer Martinez" title="Entrepreneur, CEO of Martinez Digital" image="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" data-id="element-1416" />
          </div>
          <div className="bg-navy text-white rounded-lg p-8 md:p-12" data-id="element-1417">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1418">
              <div data-id="element-1419">
                <img src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Team celebrating success" className="rounded-lg shadow-md w-full h-auto" data-id="element-1420" />
              </div>
              <div data-id="element-1421">
                <h3 className="text-2xl font-bold text-gold mb-6 font-montserrat" data-id="element-1422">
                  Community Impact
                </h3>
                <p className="mb-4" data-id="element-1423">
                  Beyond individual business success, our program creates ripple
                  effects throughout communities:
                </p>
                <ul className="space-y-3 mb-6" data-id="element-1424">
                  <li className="flex items-start" data-id="element-1425">
                    <span className="text-gold mr-2" data-id="element-1426">•</span>
                    <span data-id="element-1427">Job creation for local residents</span>
                  </li>
                  <li className="flex items-start" data-id="element-1428">
                    <span className="text-gold mr-2" data-id="element-1429">•</span>
                    <span data-id="element-1430">Economic growth in underserved areas</span>
                  </li>
                  <li className="flex items-start" data-id="element-1431">
                    <span className="text-gold mr-2" data-id="element-1432">•</span>
                    <span data-id="element-1433">
                      Innovation and advancement across various industries
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1434">
                    <span className="text-gold mr-2" data-id="element-1435">•</span>
                    <span data-id="element-1436">
                      Mentorship that extends beyond our direct participants
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1437">
                    <span className="text-gold mr-2" data-id="element-1438">•</span>
                    <span data-id="element-1439">
                      Successful entrepreneur integration into business
                      communities
                    </span>
                  </li>
                </ul>
                <p data-id="element-1440">
                  We're building more than businesses—we're building stronger
                  communities and creating opportunities for generations to
                  come.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="section-padding bg-lightGray" data-id="element-1441">
        <div className="container-custom text-center" data-id="element-1442">
          <h2 className="text-3xl md:text-4xl font-bold font-montserrat text-navy mb-6" data-id="element-1443">
            Be Our Next Success Story
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-darkGray" data-id="element-1444">
            Join our community of successful entrepreneurs and start building
            your business legacy today.
          </p>
          <CTAButton text="Apply Now" to="/apply" className="text-lg" data-id="element-1445" />
        </div>
      </section>
    </div>;
};
const StatCard = ({
  icon,
  number,
  label
}) => {
  return <div className="bg-white rounded-lg shadow-md p-6 text-center border-t-4 border-gold" data-id="element-1446">
      <div className="text-gold mb-4 flex justify-center" data-id="element-1447">{icon}</div>
      <h3 className="text-3xl font-bold text-navy mb-2 font-montserrat" data-id="element-1448">
        {number}
      </h3>
      <p className="text-darkGray" data-id="element-1449">{label}</p>
    </div>;
};
export default ImpactPage;